<div class="header flex flex-row">
  <app-header
    [class.full-screen-header]="isFullScreen"
    [class.white-bg]="makeBackgroundWhite"
    class="floating-header" />
</div>
<div #scrollContainer [class.full-screen]="isFullScreen" class="layout-content">
  <router-outlet />
</div>
<app-footer />
